import React from "react";

function ReadNotificationPopup({
  setSubmissionDescription,
  setShowSubmitPopup,
  submissionDescription,
  handleSumbit,
}) {
  return (
    <div className="img-popup-design">
      <div className="img-popup" style={{ height: "auto", padding: "20px" }}>
        <h3 className="f2 mb-3">Submit Description</h3>
        <textarea
          // className="form-control mb-3"
          rows="4"
          placeholder="Enter description here..."
          value={submissionDescription}
          onChange={(e) => setSubmissionDescription(e.target.value)}
          style={{ width: "100%", borderRadius: "8px", padding: "10px" }}
        ></textarea>
        <div className="d-flex ac-jb gap-3">
          <button onClick={handleSumbit} className="add-btn w-50">
            Submit
          </button>
          <button
            onClick={() => {
              setShowSubmitPopup(false);
              setSubmissionDescription("");
            }}
            className="back-btn f2 w-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReadNotificationPopup;
